import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as detailReducer, REDUCER_NAME as DETAIL_REDUCER_NAME } from './detail'
import { reducer as searchReducer, REDUCER_NAME as SEARCH_REDUCER_NAME } from './search'

const reducer = combineReducers({
    [DETAIL_REDUCER_NAME]: detailReducer,
    [SEARCH_REDUCER_NAME]: searchReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/sales-order/state/index.js